function initStickyAtcThreshold() {
  const stickyAtcBar = document.querySelector('.sticky-atc-bar');
  const originalBuyButton = document.querySelector('.product-form__cart-submit');
  
  if (!stickyAtcBar || !originalBuyButton) {
    console.log('Elements not found');
    return;
  }

  let isActive = false;
  let threshold = 0;


  function calculateThreshold() {
    const buttonRect = originalBuyButton.getBoundingClientRect();
    threshold = buttonRect.bottom + window.pageYOffset - 50;
  }


  function updateStickyBar() {
    const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
    
    if (currentScroll > threshold && !isActive) {

      stickyAtcBar.style.transform = 'translateY(0) translateZ(0)';
      stickyAtcBar.style.visibility = 'visible';
      isActive = true;
    } else if (currentScroll <= threshold && isActive) {
      stickyAtcBar.style.transform = 'translateY(100%) translateZ(0)';
      stickyAtcBar.style.visibility = 'hidden';
      isActive = false;
    }
  }

  
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  // Inicialização
  calculateThreshold();
  
  // Estado inicial
  stickyAtcBar.style.transform = 'translateY(100%) translateZ(0)';
  stickyAtcBar.style.visibility = 'hidden';
  isActive = false;

  
  const debouncedScroll = debounce(updateStickyBar, 10);
  const debouncedResize = debounce(calculateThreshold, 100);

  window.addEventListener('scroll', debouncedScroll, { passive: true });
  window.addEventListener('resize', debouncedResize, { passive: true });
  
  // iOS specific events
  window.addEventListener('orientationchange', function() {
    setTimeout(() => {
      calculateThreshold();
      updateStickyBar();
    }, 300);
  });

  // Recalcular em momentos estratégicos
  setTimeout(calculateThreshold, 500);
  setTimeout(calculateThreshold, 1500);
  
  // Recalcular quando imagens carregarem
  window.addEventListener('load', calculateThreshold);
  
  // Observer para mudanças no DOM
  const observer = new MutationObserver(calculateThreshold);
  observer.observe(document.body, { 
    childList: true, 
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class'] 
  });
}


document.addEventListener('DOMContentLoaded', function() {
  console.log('DOM loaded - initializing sticky ATC');
  
  function initialize() {
    if (document.querySelector('.sticky-atc-bar') && document.querySelector('.product-form__cart-submit')) {
      initStickyAtcThreshold();
      return true;
    }
    return false;
  }

  
  if (!initialize()) {
    
    const interval = setInterval(() => {
      if (initialize()) {
        clearInterval(interval);
      }
    }, 500);

   
    setTimeout(() => clearInterval(interval), 10000);
  }
});